import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import * as sweetalert from 'sweetalert';
import { Sort } from '@angular/material';
import { UUID } from 'angular2-uuid';
//grid
import { AgGridNg2 } from 'ag-grid-angular';
import { } from '@types/googlemaps';
import { forEach } from '@angular/router/src/utils/collection';

import { Zona } from '../Models/Zona';
import { Ruta } from '../Models/Ruta';
import { Cerca } from '../Models/Cerca';
import { Coordinates } from '../Models/Coordinates';

import { ZonaService } from '../services/zona.service';
import { RutaService } from '../services/ruta.service';
import { GlobalsService } from '../services/globals.service';
import { GeolocationService } from '../services/geolocation.service';
import { UtilesService } from '../services/utiles.service';


@Component({
  selector: 'app-ruta',
  templateUrl: './ruta.component.html',
  styleUrls: ['./ruta.component.css']
})
export class RutaComponent implements OnInit {

  public zonas: Zona[];

  public ruta: Ruta = new Ruta();
  public rutas: Ruta[];

  public modoEdicion: boolean = false;
  public nuevoRegistro: boolean = false;
  public mostrarMapa: boolean = false;

  public IdZona: number;

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;

  public latitude: number = 9.935638;
  public longitude: number = -84.143464;

  private cercaCoords = []; //Array de coordenas ordenadas 
  private geoCerca; //Polígono dentro del mapa
  private marcadorCoords = []; //Array de marcadores del polígonos
  private geoCercaCreada: boolean = false;

  private longSecundaria;

  private markers = [];

  //grid
  @ViewChild('agGrid') agGrid: AgGridNg2;

  title = 'Rutas';

  columnDefs = [
    //  {headerName: 'Identificador', field: 'idRuta' },
    { headerName: 'Descripción', field: 'descripcion', icons: { filter: ' ' } },

  ];

  rowData: any[];

  constructor(
    private geoService: GeolocationService,
    private zonaService: ZonaService,
    private rutaService: RutaService,
    private globalServices: GlobalsService) {

  }

  ngOnInit() {

    this.modoEdicion = false;
    this.crearMapa();

    this.CargarZonas();

  }

  CargarZonas() {

    try {

      this.zonaService.ObtenerZonas(this.globalServices.ObtenerCompania()).subscribe(
        data => {
          this.zonas = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("Cargarzonas: " + error);
    }
  }


  ZonaSeleccionada() {
    try {

      this.CargarRutas();

    } catch (error) {
      console.log("ZonaSeleccionada: " + error);
    }
  }

/**
 * Guarda la ruta en la bd
 */
  GuardarRegistro() {

    this.ruta.idCompania = this.globalServices.ObtenerCompania();
    this.ruta.idZona = this.IdZona;

    this.rutaService.GuardarRegistro(this.ruta).subscribe(

      result => {

        swal("Registro guardado con éxito!", "", "success");

        this.ruta = new Ruta();
        this.modoEdicion = false;

        this.CargarRutas();
      },
      err => {
        console.log(err._body);
      });


  }

  CargarRutas() {
    try {

      this.rutaService.ObtenerRutas(this.globalServices.ObtenerCompania(), this.IdZona.toString()).subscribe(
        data => {
          this.rutas = data;
          this.rowData = this.rutas;
        },
        err => {
          console.clear();
          console.log(err._body);

        });

    } catch (error) {
      console.log("CargarRutas:" + error);
    }
  }

  NuevoRegistro() {
    this.nuevoRegistro = true;
    this.ruta = new Ruta();
    this.modoEdicion = true;
    this.limpiarPoligono();
  }

  CancelarEdicion() {

    this.ruta = new Ruta();
    this.modoEdicion = false;
    this.limpiarPoligono();
  }

  edicion(): boolean {

    if (this.mostrarMapa) {
      return false;
    }

    return this.modoEdicion;

  }

  /*
    Gestión de mapas
  */

  HabilitarMapa() {
    this.mostrarMapa = true;


    if (this.cercaCoords.length > 0) {
      this.mostrarPoligono();
    }

  }

  crearMapa() {
    try {

      this.map = new google.maps.Map(this.gmapElement.nativeElement, {
        center: {
          lat: this.latitude,
          lng: this.longitude
        },
        zoom: 8
      });

      google.maps.event.addListener(this.map, 'click', this.updateLocation.bind(this));

      // google.maps.event.addListener(this.map, 'dragend', this.updateLocationDragg.bind(this));
    } catch (error) {

    }
  }

  private updateLocation(event) {

    let location = event.latLng.toString();

    let loc = event.latLng.toJSON()

    this.cercaCoords.push({ lat: loc.lat, lng: loc.lng });

    var image = 'https://developers.google.com/maps/documentation/javascript/examples/full/images/beachflag.png';

    var marker = new google.maps.Marker({
      position: { lat: loc.lat, lng: loc.lng },
      map: this.map,
      // title: 'Hello World!',
      //  draggable: true,
      icon: image

    });

    this.markers.push(marker);

  }


  mostrarPoligono() {

    if (this.geoCerca != undefined) {
      this.geoCerca.setMap(null);
    }
    this.geoCerca = new google.maps.Polygon({
      paths: this.cercaCoords,
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 3,
      fillColor: '#FF0000',
      fillOpacity: 0.35
    });
    this.geoCerca.setMap(this.map);

  }

  limpiarPoligono() {
    try {

      this.geoCerca.setMap(null);

      this.cercaCoords = [];

      for (var i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null);
      }
      this.markers = [];


      //this.ruta.cerca = [];

    } catch (error) {

    }
  }

  cargarGeoCerca() {
    try {

      if (this.cercaCoords.length === 0) {
        return;
      }

      let cerca = [];

      for (var i = 0; i < this.cercaCoords.length; i++) {

        let item = new Cerca();

        item.idcompania = this.globalServices.ObtenerCompania();
        // item.idgeocerca = UUID.UUID();
        item.idruta = this.IdZona;
        item.idruta = this.ruta.idRuta;
        item.latitud = this.cercaCoords[i].lat;
        item.longitud = this.cercaCoords[i].lng;

        cerca.push(item);

      }

      this.ruta.cerca = cerca;

      this.geoCercaCreada = true;

      this.mostrarMapa = false;

    } catch (error) {

    }
  }

  cancelarCerca() {

    if (!this.geoCercaCreada) {
      this.limpiarPoligono();
    }

    this.mostrarMapa = false;

  }


  private onCellClicked($event) {

    console.log('onCellClicked: ' + $event.rowIndex + ' ' + $event.colDef.field);
    let row = $event.rowIndex;
    let datos = JSON.parse(JSON.stringify($event.data));

    //Se debe clonar el item para que no afecte el array origen en memoria
    this.nuevoRegistro = false;
    this.ruta = datos;

    this.ruta.cerca = this.ruta.cerca;

    this.geoCercaCreada = true;

    this.limpiarPoligono();


    if (this.ruta.cerca != undefined) {
      for (var i = 0; i < this.ruta.cerca.length; i++) {
        let lati = parseFloat(this.ruta.cerca[i].latitud);
        let long = parseFloat(this.ruta.cerca[i].longitud);

        this.cercaCoords.push({ lat: lati, lng: long });
      }
    }

    this.modoEdicion = true;

  }


}

